<template>
  <div v-loading="loading">
    <el-row style="height: 30px">
      <el-col :span="24"> 代采计划单号{{ $route.params.id }} </el-col>
    </el-row>

    <div class="blockinfo">
      <div style="height: 50px; line-height: 50px">代采计划单信息</div>
      <el-row v-if="resData">
        <el-col :span="8">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>申请人：</span>
                <span>{{ resData.admin_name }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>市场：</span>
                <span>{{ resData.market_name }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>代采类型：</span>
                <span>{{ resData.plan_type }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>商家：</span>
                <span>{{ resData.supply_name }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>代采员：</span>
                <span>{{ resData.m_name }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>提交时间：</span>
                <span>{{ resData.create_time }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>审核时间：</span>
                <span>{{ resData.wp_check_time }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>需求日期：</span>
                <span>{{ resData.wp_demanded_date }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="resData.stocking_id > 0">
            <el-col :span="24">
              <div class="info-row">
                <span>备货单号：</span>
                <span>{{ resData.stocking_id }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div style="margin-bottom: 20px">
      <div class="card-title">
        代采计划商品：计划代采共{{ resData && resData.plan_num }}件，计{{
          resData && resData.plan_price_total
        }}

        <el-button
          style="margin-left: auto; float: right"
          type="success"
          size="mini"
          @click="output"
          >导出</el-button
        >
      </div>
      <el-table
        v-if="resData"
        :data="resData.plan_goods"
        border
        style="width: 100%"
        height="400"
      >
        <el-table-column label="序号" type="index" align="center">
        </el-table-column>
        <el-table-column prop="goods_kh" label="商品款号" align="center">
        </el-table-column>
        <el-table-column prop="goods_no" label="商品货号" align="center">
        </el-table-column>
        <el-table-column prop="goods_name" label="商品名称" align="center">
        </el-table-column>
        <el-table-column prop="goods_label" label="入仓标签" align="center">
        </el-table-column>
        <el-table-column prop="brand_name" label="品牌" align="center">
        </el-table-column>
        <el-table-column prop="goods_img" label="商品图片" align="center">
          <template #default="scope">
            <div
              v-viewer
              style="
                width: 40px;
                height: 40px;
                overflow: hidden;
                cursor: pointer;
                display: inline-block;
              "
            >
              <img
                :src="scope.row.goods_img"
                style="width: 100%; height: 100%"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="co_val" label="商品颜色" align="center">
        </el-table-column>
        <el-table-column prop="si_val" label="商品尺码" align="center">
        </el-table-column>
        <el-table-column
          prop="plan_price"
          label="代采单价"
          align="center"
          width="150px"
        >
          <template #default="scope">
            <ys-input
              v-if="
                resData.plan_type_id === PLAN_TYPE.UP_FLOW_PLAN &&
                resData.status === REVIEW_STATUS.PENDING_REVIEW
              "
              v-model="scope.row.plan_price"
              :min="0"
              pattern="money"
              @change="
                handlePlanPriceEdit(
                  scope.row.plan_info_id,
                  scope.row.plan_price
                )
              "
            >
            </ys-input>
            <div v-else>{{ scope.row.plan_price }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="plan_num" label="代采数量" align="center">
        </el-table-column>
        <el-table-column prop="wait_order_num" label="待开单" align="center">
        </el-table-column>
        <el-table-column prop="wait_cancel_num" label="急救箱" align="center">
        </el-table-column>
        <el-table-column prop="cancel_num" label="已断货" align="center">
        </el-table-column>
        <el-table-column
          prop="finance_wait_confirm_num"
          label="财务待审核"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="ok_num" label="已完成" align="center">
        </el-table-column>
        <el-table-column
          prop="plan_price_total"
          label="计划代采金额"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ok_price_total"
          label="财务已支付"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="pg_name" label="买手组" align="center">
        </el-table-column>
        <el-table-column prop="pgname" label="代采组" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" show-overflow-tooltip>
          <template #default="scope">
            <el-button
              v-if="
                scope.row.gl_supply_id != resData.supply_id &&
                scope.row.info_status == 1
              "
              type="text"
              size="small"
              @click="moveOutPurchasePlan(scope.row)"
              >迁出代采计划</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div>
      <div style="padding-bottom: 300px">
        <el-input
          v-model="textarea"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
        ></el-input>
        <div v-if="resData" style="text-align: right; margin-top: 20px">
          <el-button
            v-if="resData.status == 11"
            type="primary"
            size="small"
            @click="updateCheck(1)"
            >审核通过</el-button
          >
          <el-button
            v-if="resData.status == 11"
            size="small"
            @click="updateCheck(0)"
            >驳回</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

const PLAN_TYPE = {
  UP_FLOW_PLAN: "15", // 加流备货
};
const REVIEW_STATUS = {
  TAKE_EFFECT: "0", // 已生效
  PENDING_REVIEW: "11", // 待审核(原计划草稿)
  VOIDED: "12", // 作废计划
};
export default {
  name: "PurchasePlanDetail",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.resData) {
        vm.fetchData();
      }
    });
  },
  data() {
    return {
      form: {
        is_excel: 0,
      },
      resData: null,
      textarea: "",
      loading: false,
      files: [],
      dialogTableVisible: false,
      operationLog: null,
      dialogGoods: null,
      editable: false,
      index: null,
      paytime: "",
      initData: "",
      url: "/erp/wcgPlan/getInfo",
      updatePlanPrices: [],
      PLAN_TYPE,
      REVIEW_STATUS,
    };
  },
  computed: {
    filteredFiles() {
      const arr = [];
      this.files.forEach((v) => {
        arr.push(v.response.data.files[0]);
      });
      return arr;
    },
  },
  methods: {
    output() {
      this.form.is_excel = 1;
      this.loading = true;
      this.$http
        .post(this.url, {
          planid: this.$route.params.id,
          is_excel: 1,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.loading = false;
            this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    confirmUpload() {
      const uploadUrl = "/erp/WcgOrder/uploadReceiptOfOrderPay";
      const uploadArgs = {
        woid: this.$route.params.id,
        files: this.filteredFiles,
      };
      this.$http.post(uploadUrl, uploadArgs).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          this.files = [];
        } else {
          this.files = [];
          this.$message({
            message: "上传成功",
            type: "success",
          });
          setTimeout(() => {
            this.fetchData();
          }, 200);
        }
      });
    },
    confirmUpdate() {
      const updateUrl = "/erp/WcgOrder/updateReceiptOfOrderPay";
      const updateArgs = {
        woid: this.$route.params.id,
        files: this.filteredFiles,
      };
      this.$http.post(updateUrl, updateArgs).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          this.files = [];
        } else {
          this.files = [];
          this.$message({
            message: "上传成功",
            type: "success",
          });
          setTimeout(() => {
            this.fetchData();
          }, 200);
        }
      });
    },
    update(val, index) {
      const item = this.info.goodsList[index];
      const { woiid } = item;
      const { price } = item;

      if (Number(this.initData) === Number(price)) {
        return;
      }

      this.$confirm("确定修改价格?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const url = "/erp/WcgOrder/updatePrice";
          const args = {
            woiid,
            price,
          };
          this.$http.post(url, args).then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
              this.fetchData();
            } else {
              this.$message({
                type: "success",
                message: "修改成功!",
              });
              this.fetchData();
              this.initData = "";
            }
          });
        })
        .catch(() => {
          this.fetchData();
          this.$message({
            type: "info",
            message: "已取消修改",
          });
          this.initData = "";
        });
    },

    updatePaytime(index) {
      this.index = this.index === null ? index : null;

      if (this.paytime) {
        const args = {
          datetime: this.paytime,
          woid: this.$route.params.id,
        };
        const url = "/erp/WcgOrder/updatePayTime";
        this.$http.post(url, args).then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.fetchData();
          }
          this.paytime = "";
          this.index = null;
        });

        this.index = null;
        this.paytime = "";
      }
    },
    edit() {
      this.editable = !this.editable;
    },
    /**
     * 仅保留每个 `plan_info_id` 的最后一次出现。
     * @param {Array} inputArr - 输入的项数组。
     * @returns {Array} - 一个新数组，仅包含每个 `plan_info_id` 的最后一次出现。
     */
    filterDuplicatePlanInfoId(inputArr) {
      if (!Array.isArray(inputArr) || inputArr.length === 0) {
        return [];
      }
      // 创建一个 Map 来存储基于 `plan_info_id` 的唯一项
      const uniqueItems = new Map();
      inputArr.forEach((item) => {
        const { plan_info_id: planInfoId, plan_price: _planPrice = "" } = item;
        const planPrice =
          _planPrice.trim() !== "" ? parseFloat(_planPrice.trim()) : 0;
        const value = {
          plan_info_id: Number(planInfoId),
          plan_price: planPrice,
        };
        uniqueItems.set(item.plan_info_id, value);
      });
      const result = Array.from(uniqueItems.values());
      return result;
    },
    updateCheck(bool) {
      const _bool = Number(bool);
      const url = "/erp/wcgPlan/updateCheck";
      const editJson = this.filterDuplicatePlanInfoId(this.updatePlanPrices);
      const args = {
        check_remarks: this.textarea,
        planid: this.$route.params.id,
        status: _bool,
        edit_json: editJson,
      };
      const confirmTxt = _bool ? "是否通过审核？" : "是否驳回？";
      this.$confirm(confirmTxt, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;

          this.$http.post(url, args).then((res) => {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$notify({
                title: "操作成功",
                message: "",
                type: "success",
              });
              setTimeout(() => {
                this.fetchData();
              }, 300);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    handleRemove(file) {
      const index = this.files.indexOf(file.response.data.files[0]);
      if (index > -1) {
        this.files.splice(index, 1);
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    uploadSuccess(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        // this.files = this.files.concat(res.data.files);
        this.files = fileList;
      }
    },
    moveOutPurchasePlan(row) {
      this.$http
        .post("/erp/wcgPlan/getGoodsLibData", {
          goods_no: row.goods_no,
        })
        .then((res) => {
          if (res.data.data) {
            this.$msgbox({
              title: "迁出代采计划商品",
              message:
                `<div style="background: #F5FBFE">` +
                `<p>商品货号:${row.goods_no}</p>` +
                `<p>当前商家:${res.data.data.supply_name}</p>` +
                `<p>市场:${res.data.data.market_name}</p>` +
                `<p>代采组:${res.data.data.pgname}</p>` +
                `<p>代采员:${res.data.data.m_name}</p>` +
                `</div>` +
                `<div>` +
                `<p>以上是该商品最新信息,是否确定将此商品的代采计划迁出</p>` +
                `</div>`,
              showCancelButton: true,
              dangerouslyUseHTMLString: true,
            }).then(() => {
              this.$http
                .post("/erp/wcgPlan/reloadPlan", {
                  plan_id: this.$route.params.id,
                  goods_no: row.goods_no,
                  plan_info_id: row.plan_info_id,
                })
                .then((resp) => {
                  if (resp.data.code !== 200) {
                    this.$message.error(resp.data.msg);
                  } else {
                    this.$message.success(resp.data.msg);
                    // 重新拉取数据
                    this.fetchData();
                  }
                });
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    fetchData() {
      const url = "/erp/wcgPlan/getInfo";
      const args = {
        planid: this.$route.params.id,
      };
      //   this.loading = true;
      this.$http.post(url, args).then((res) => {
        // this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.textarea = res.data.data.check_remarks;
        }
      });
    },
    handlePlanPriceEdit(planInfoId, planPrice) {
      if (!planInfoId || !planPrice.trim()) {
        return;
      }
      const paramObj = {
        plan_info_id: planInfoId,
        plan_price: planPrice,
      };
      this.updatePlanPrices.push(paramObj);
    },
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.card-title {
  background: #f3f3f3;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
}

.highlight {
  color: red;
}

.blockinfo {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  padding: 0 10px 20px;
  margin-bottom: 20px;
}

.info-row {
  color: #666;
  font-size: 14px;

  /* height: 38px;
  line-height: 38px; */
}

.info-row > span:first-child {
  color: #333;
}

.order-log {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchasePlanDetail.vue